export class EnrollCommissionDecision {
  id = 0;
  educated = 0;
  lang = 0;
  speciality = 0;
  qualification = 0;
  collegeId = 0;
  confirmedTime = null;
  mustBeDecidedByCommission = false;
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/enroll-commission-decision.ts